import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/cancel.svg'
import _imports_1 from '../assets/icons/plus-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-0a8bb373"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "holder" }
const _hoisted_2 = { class: "operator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "||", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "flip"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "two-columns" }
const _hoisted_10 = { class: "segments" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "sides" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 607 607" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "303.309",
    cy: "303.309",
    r: "297.059"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M93.257,513.362l420.105,-420.105" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M93.257,93.257l420.105,420.105" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Palm", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"position":"relative","top":"3px"}
}, null, -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "flex-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

import { getFancyPhalanx } from '../utils'
import { ref, computed } from 'vue'


export default {
  __name: 'PhalanxInput',
  props: {
  modelValue: {},
  canDestroy: { type: Boolean, default: false }
},
  emits: ['update:modelValue', 'close'],
  setup(__props, { emit: emits }) {

const props = __props;





const phalanxes = computed({
  get () {
    return props.modelValue ?? []
  },
  set (value) {
    emits('update:modelValue', value)
  }
})

const customV = ref('')

function addMode (x) {
  if (phalanxes.value.length === 0) return

  const lastAct = phalanxes.value[phalanxes.value.length - 1]
  if (x === '|') {
    if (lastAct.length > 1) {
      const lastFinger = lastAct[lastAct.length - 1]
      if (lastFinger.segment.length === 0 && lastFinger.side.length === 0) {
        lastAct.pop()
      }
      phalanxes.value.push([{ segment: '', side: '' }])
    } else if (lastAct.length === 1) {
      phalanxes.value.push([{ segment: '', side: '' }])
    }
  } else if (x === '||') {
    if (lastAct.length === 0 || (lastAct.length === 1 && lastAct[0].length === 0)) {
      phalanxes.value.pop()
      phalanxes.value[phalanxes.value.length - 1].push({ segment: '', side: '' })
    } else {
      lastAct.push({ segment: '', side: '' })
    }
  }
}

function addSegment (s) {
  if (phalanxes.value.length === 0) {
    phalanxes.value.push([{ segment: s, side: '' }])
  } else {
    const lastAct = phalanxes.value[phalanxes.value.length - 1]
    const lastFinger = lastAct[lastAct.length - 1]
    lastFinger.segment = s
  }
}

function addSide (s) {
  if (phalanxes.value.length === 0) {
    phalanxes.value.push([{ segment: '', side: s }])
  } else {
    const lastAct = phalanxes.value[phalanxes.value.length - 1]
    const lastFinger = lastAct[lastAct.length - 1]
    lastFinger.side = s
  }
}

function removePhalanx () {
  if (phalanxes.value.length === 0) return
  const lastValue = phalanxes.value[phalanxes.value.length - 1]
  if (lastValue.length > 1) {
    const l = lastValue.pop()
    if (l.length) lastValue.push({ segment: '', side: '' })
  } else if (lastValue.length === 1 && (lastValue[0].segment.length > 0 || lastValue[0].side.length > 0)) {
    lastValue[0] = { segment: '', side: '' }
  } else {
    phalanxes.value.pop()
  }
}

function addPalm () {
  if (phalanxes.value.length === 0) {
    phalanxes.value.push([{ segment: 'palm', side: '' }])
  } else {
    const lastAct = phalanxes.value[phalanxes.value.length - 1]
    const lastFinger = lastAct[lastAct.length - 1]
    lastFinger.segment = 'palm'
    lastFinger.side = ''
  }
}

function addCustom () {
  if (phalanxes.value.length === 0) {
    phalanxes.value.push([{ segment: customV.value, side: '' }])
  } else {
    const lastAct = phalanxes.value[phalanxes.value.length - 1]
    const lastFinger = lastAct[lastAct.length - 1]
    lastFinger.segment = customV.value
    lastFinger.side = ''
  }
}

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = $event => (emits('close')))
    }, [
      _createVNode(_component_unicon, { name: "times-circle" })
    ]),
    _createTextVNode(" " + _toDisplayString(_unref(getFancyPhalanx)(_unref(phalanxes))) + " ", 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "round-button",
        onClick: _cache[1] || (_cache[1] = $event => (addMode('|')))
      }, _hoisted_4),
      _createElementVNode("div", {
        class: "round-button",
        onClick: _cache[2] || (_cache[2] = $event => (addMode('||')))
      }, _hoisted_6),
      _createElementVNode("span", { onClick: removePhalanx }, _hoisted_8)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['tip', 'middle', 'base'], (s) => {
          return _createElementVNode("div", {
            key: `${s}`,
            onClick: $event => (addSegment(s))
          }, [
            _createElementVNode("span", null, _toDisplayString(s), 1)
          ], 8, _hoisted_11)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['dorsal','front', 'left', 'right'], (s) => {
          return _createElementVNode("div", {
            key: `${s}`,
            style: _normalizeStyle(`grid-area: ${s}`),
            onClick: $event => (addSide(s))
          }, _toDisplayString(s), 13, _hoisted_13)
        }), 64)),
        _hoisted_14
      ])
    ]),
    _createElementVNode("div", {
      onClick: addPalm,
      class: "flex-center"
    }, _hoisted_17),
    _createElementVNode("div", _hoisted_18, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((customV).value = $event))
      }, null, 512), [
        [_vModelText, customV.value]
      ]),
      _createElementVNode("div", { onClick: addCustom }, _hoisted_20)
    ]),
    (__props.canDestroy)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "destroy-button",
          onClick: _cache[4] || (_cache[4] = $event => {emits('destroy'); emits('close')})
        }, [
          _createVNode(_component_unicon, { name: "trash-alt" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}